import React, { useState } from 'react'
import { Autocomplete, CircularProgress } from '@mui/material'
import { useDebounce } from 'use-debounce'
import useAsyncSearch from '../../../hooks/useAsyncSearch'
import { searchCustomers } from '../../../apis/backendRequests'
import { StyledTextField } from '../../../ui/StyledComponents'

const MIN_SEARCH_LENGTH = 2
const searchParams = []
const noResults = []

const clienteLabel = (cliente) => (cliente ? `${cliente.customerNumber} - ${cliente.customerName}` : '')

// La API ya filtra por número o nombre: el Autocomplete no vuelve a filtrar las opciones
const keepOptions = (options) => options

// Cliente de GP para filtrar los documentos candidatos. `value` es { customerNumber, customerName } o null
export default function ClienteAutocomplete({ value, onChange, disabled, sx }) {
    const [inputValue, setInputValue] = useState('')
    const [debounced] = useDebounce(inputValue.trim(), 500)
    // El texto del cliente ya elegido no se vuelve a buscar
    const term = debounced.length >= MIN_SEARCH_LENGTH && debounced !== clienteLabel(value) ? debounced : ''

    const [loading, clientes] = useAsyncSearch({
        term,
        request: searchCustomers,
        params: searchParams,
        defaultValue: noResults,
    })

    const options = value && !clientes.some((c) => c.customerNumber === value.customerNumber)
        ? [value, ...clientes]
        : clientes

    return (
        <Autocomplete
            size="small"
            options={options}
            value={value}
            inputValue={inputValue}
            onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
            onChange={(_, newValue) => onChange(newValue)}
            getOptionLabel={clienteLabel}
            isOptionEqualToValue={(a, b) => a.customerNumber === b.customerNumber}
            filterOptions={keepOptions}
            loading={loading}
            loadingText="Buscando clientes..."
            noOptionsText={inputValue.trim().length < MIN_SEARCH_LENGTH
                ? `Escribí al menos ${MIN_SEARCH_LENGTH} letras del número o el nombre`
                : 'No hay clientes con ese número o nombre'}
            disabled={disabled}
            sx={sx}
            renderInput={(params) => (
                <StyledTextField
                    {...params}
                    label="Cliente"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={18} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    )
}
